import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Skeleton,
} from "@mindstonehq/ui";
import {
  hasAnyCommunitySignal,
  type CommunitySignals,
} from "~/lib/community-signals-types";
import { deriveActivitySignal } from "~/lib/profile-celebration";
import ProfileActivityTimeline from "./profile-activity-timeline";
import ProfileTalksPortfolio from "./profile-talks-portfolio";
import ProfileVerifiedLearning from "./profile-verified-learning";

export function ProfileCommunitySkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-hidden>
      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-4 w-48" />
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-4 w-1/2" />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-4 w-56" />
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </CardContent>
      </Card>
    </div>
  );
}

function BuildProfilePromptCard() {
  return (
    <Card className="bg-muted/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <CheckBadgeIcon className="size-5 text-muted-foreground" />
          Build your public AI profile
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">
        Speak, host, attend, or ask questions at Mindstone events, or test
        what you learned after one. Verified activity will appear here for
        visitors.
      </CardContent>
    </Card>
  );
}

export default function ProfileCommunity({
  signals,
  isCurrentUser,
}: {
  signals: CommunitySignals | null;
  isCurrentUser: boolean;
  firstName?: string | null;
}) {
  if (!hasAnyCommunitySignal(signals)) {
    if (!isCurrentUser) return null;
    return <BuildProfilePromptCard />;
  }

  return (
    <div className="flex flex-col gap-6">
      <ProfileTalksPortfolio
        talks={signals.talks}
        isCurrentUser={isCurrentUser}
      />
      <ProfileVerifiedLearning
        verifiedLearning={signals.verifiedLearning}
        isCurrentUser={isCurrentUser}
      />
      <ProfileActivityTimeline
        activity={deriveActivitySignal(signals)}
        questions={signals.questions}
        connections={signals.connections}
        isCurrentUser={isCurrentUser}
      />
    </div>
  );
}
